export default {
  __name: 'noFooter',
  setup(__props) {


return { __sfc: true, }
}

}